/** Internal type. DO NOT USE DIRECTLY. */
import { gql } from "@apollo/client"

import * as Types from "../../types/__generated__/graphql"

export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never
    }

export type PriceGroupFragment = {
  __typename: "PriceGroup"
  name: string
  priceTotal: number
  isComplete?: boolean | null
  parentPriceGroup: string
  groupType: string
}

export type ProjectPriceFragment = {
  __typename: "ProjectPrice"
  id: string
  priceTotal: number
  isComplete: boolean
  isValid?: boolean | null
  currency: string
  groups?: Array<{
    __typename: "PriceGroup"
    name: string
    priceTotal: number
    isComplete?: boolean | null
    parentPriceGroup: string
    groupType: string
  }> | null
}

export type RoomPriceFragment = {
  __typename: "RoomPrice"
  id: string
  priceTotal: number
  isComplete: boolean
  isValid?: boolean | null
  currency: string
}

export type FloorPriceFragment = {
  __typename: "FloorPrice"
  id: string
  priceTotal: number
  isComplete: boolean
  isValid?: boolean | null
  currency: string
}

export type ProductPriceFragment = {
  __typename: "ProductPrice"
  id: string
  itemPrice: number
  priceTotal: number
  isComplete: boolean
  isValid?: boolean | null
  currency: string
  groups?: Array<{
    __typename: "PriceGroup"
    name: string
    priceTotal: number
    isComplete?: boolean | null
    parentPriceGroup: string
    groupType: string
  }> | null
}

export type ArticleNumberSearchResultsFragment = {
  __typename: "ArticleNumberSearchResults"
  id: string
  variantKey?: string | null
}

export const PriceGroupFragmentDoc = gql`
  fragment PriceGroup on PriceGroup {
    name
    priceTotal
    isComplete
    parentPriceGroup
    groupType
  }
`
export const ProjectPriceFragmentDoc = gql`
  fragment ProjectPrice on ProjectPrice {
    id
    priceTotal
    isComplete
    isValid
    currency
    groups @type(name: "PriceGroup") {
      ...PriceGroup
    }
  }
  ${PriceGroupFragmentDoc}
`
export const RoomPriceFragmentDoc = gql`
  fragment RoomPrice on RoomPrice {
    id
    priceTotal
    isComplete
    isValid
    currency
  }
`
export const FloorPriceFragmentDoc = gql`
  fragment FloorPrice on FloorPrice {
    id
    priceTotal
    isComplete
    isValid
    currency
  }
`
export const ProductPriceFragmentDoc = gql`
  fragment ProductPrice on ProductPrice {
    id
    itemPrice
    priceTotal
    isComplete
    isValid
    currency
    groups @type(name: "PriceGroup") {
      ...PriceGroup
    }
  }
  ${PriceGroupFragmentDoc}
`
export const ArticleNumberSearchResultsFragmentDoc = gql`
  fragment ArticleNumberSearchResults on ArticleNumberSearchResults {
    id
    variantKey
  }
`
